import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './templates/TravelExpenseForm.html?raw';
import domConstructTyped from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import lang from 'dojo/_base/lang';
// NOTE (JS2TS): dropped dead dojo deps (dom-style, _base/connect, on). DOM-heavy → dom-construct aliased.

const domConstruct: any = domConstructTyped;

class TravelExpenseForm extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    associateID: any = null;
    projectID: any = null;
    externalButton: any = null;
    jsonEntitylist: any = null;
    submitCallback: any = null;
    startup(): void {
        this.loadEmployments();

    }

    showSpinner(): void {
        //spinners.global().spin(document.getElementById('modalSpinner'));
        //domClass.remove(this.modalSpinnerContainer, "w3-hide");
        this.StandbyStart();
    }

    stopSpinner(): void {
        //spinners.global().stop();
        //domClass.add(this.modalSpinnerContainer, "w3-hide");
        this.StandbyStop();
    }

    loadEmployments(): void {

        this.showSpinner();

        domConstruct.empty(this.employmentSelectContainer);
        domClass.add(this.employmentSelectContainer, "w3-disabled");
        domClass.add(this.formContainer, "w3-hide");
        this.resetMessage();

        var url = window.appRoot + "SOV/TravelExpensesGetEmploymentsWithoutExpenses";

        this.RequestManager.post(
            url,
            {
                associateID: this.associateID,
                projectID: this.projectID,
            },
            lang.hitch(this, "_onLoadEmploymentsResponse"),
            lang.hitch(this, "_onLoadEmploymentsError"),
            false // sync
        );
    }

    _onLoadEmploymentsResponse(response: any): void {
        var jsonEntitylist = JSON.parse(response);
        console.log("_onLoadEmploymentsResponse", jsonEntitylist);

        this.jsonEntitylist = jsonEntitylist;

        // Select-Optionen erzeugen...
        if (jsonEntitylist.length == 0) {
            // Benutzer informieren dass er keine Dienste hat, lol...
            (window as any).spinners.global().stop(); // JS2TS: 'spinners' is an undefined global in the original (leaked global) — preserved
            this.setMessage("Es sind keine Dienste ohne bereits eingetragene Fahrtkosten vorhanden.");
            domClass.add(this.actionContainer, "w3-hide");
            return;
        }

        domClass.remove(this.formContainer, "w3-hide");
        domClass.remove(this.actionContainer, "w3-hide");

        for (var i = 0; i < jsonEntitylist.length; i++) {
            var entity = jsonEntitylist[i];

            var option = domConstruct.create("option", {
                value: entity.ID,
                innerHTML: entity.ref_ev_booking.gDisp_1
            }, this.employmentSelectContainer);
        }

        domClass.remove(this.employmentSelectContainer, "w3-disabled");

        this.stopSpinner();
    }

    _onLoadEmploymentsError(error: any): void {
        console.log("_onLoadEmploymentsError", error);
        this.setMessage(error.Message);
        domClass.add(this.actionContainer, "w3-hide");
        this.stopSpinner();
    }

    _onChange_Select(evt: any): void {
        console.log("_onChange_Select", this.employmentSelectContainer.value);
    }

    _onClick_Submit(evt: any): void {
        this.resetMessage();
        var result = this.checkInput();
        if (result === false) {
            return;
        }

        if (typeof (this.submitCallback) == "function") {
            this.showSpinner();
            this.submitCallback(result);
        }
    }

    checkInput(): any {
        var data: any = {};
        var mandatoryDataCounter = 2;
        var messageAddon = "";

        var value = this.inputRouteDescription.value;

        if (value != "") {
            data.routeDescription = value;

            mandatoryDataCounter--;
        } else {
            messageAddon += " Streckenbeschreibung;";
        }

        var bCheck = false;
        if (this.kmSingle.value != "") {
            data.kmSingle = this.kmSingle.value;
            bCheck = true;
        }

        if (this.kmPool.value != "") {
            data.kmPool = this.kmPool.value;
            bCheck = true;
        }

        if (this.kmPublic.value != "") {
            data.kmPublic = this.kmPublic.value;
            bCheck = true;
        }

        if (bCheck === true) {
            mandatoryDataCounter--;
        } else {
            messageAddon += " mindestens 1 km-Angabe;";
        }

        data.copassengerNames = this.inputCopassengerNames.value;

        data.employmentID = this.employmentSelectContainer.value;


        if (mandatoryDataCounter != 0) {
            this.setMessage("Es fehlen Angaben:" + messageAddon);

            return false;
        }

        return data;
    }

    setMessage(message: any): void {
        //domClass.add(this.employmentSelectContainer, "w3-hide");
        domAttr.set(this.messageNode, "innerHTML", message);

        //this._timeoutFct = setTimeout(lang.hitch(this, "resetMessage"), 4000);
    }

    resetMessage(): void {
        //domClass.remove(this.employmentSelectContainer, "w3-hide");
        domConstruct.empty(this.messageNode);
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

}
TravelExpenseForm.prototype.declaredClass = 'WidgetCollection.SOV.legacy.Main.TravelExpenseForm';

export default mdsWidget(TravelExpenseForm);
